// wiring.ts — 데이터·API 배선(개발자 소유). 컨덕터는 이 파일이 없을 때 한 번 만들고 다시 건드리지 않는다.
//  화면 파일은 컨덕터가 재핸드오프 때 통째로 덮어쓴다 — 배선은 여기에만 둔다. 계약(Wiring)은 화면 파일이 낸다(문서 50).
//  최초 골격: pbo-conductor — 입고작업 2.0 (gl17)
//  1.0 GL09 → 2.0 GL17 (LOGISPRD-16037). moms-be 2.0 API(스캔·공통 파일·첨부 저장)만 부른다.
//
//  상태·동작은 훅 하나(hooks/useInboundWork)가 쥔다. 엔트리(index.tsx)가 렌더마다 그 결과를 bindInboundWork 로 넘기고,
//  아래 슬롯은 그것을 읽기만 한다 — 같은 훅을 슬롯 여러 곳에서 부르지 않는다(배선 체크 ⑦).
//  엔트리가 생성본의 부모라 훅 상태가 바뀌면 생성본도 다시 그려져 슬롯이 최신 값을 읽는다.
import type { Wiring } from './page.generated'
import type { InboundWorkController } from './hooks/useInboundWork'

let current: InboundWorkController | null = null

/** 엔트리가 렌더마다 부른다. 언마운트 때 null 로 비운다(모듈 변수가 다음 탭으로 새지 않게, 배선 체크 ⑤). */
export const bindInboundWork = (controller: InboundWorkController | null): void => {
  current = controller
}

const ctl = (): InboundWorkController => {
  if (!current) throw new Error('입고작업 2.0 배선이 엔트리(index.tsx)에 묶이지 않았습니다.')
  return current
}

export const wiring: Wiring = {
  rows: {
    // 스캔 결과(직전 스캔 송장의 입고 정보). 스캔은 조회 조건·페이저가 없다.
    ROWS: () => ({ rows: ctl().rows, loading: ctl().scanning }),
  },
  actions: {
    // 저장 — 업로드가 끝난 첨부의 파일 ID 를 원본송장 최신 스캔 이력에 붙인다. 업로드 중·녹화 중·원본송장 없음은 안내 후 중단
    gl17SaveButton: () => ctl().save(),
    gl17RecordStartButton: () => ctl().startRecording(),
    gl17RecordStopButton: () => ctl().stopRecording(),
    // 송장·특수 바코드 Enter — 검증 → scan API → 판정 문구 → 라벨 자동 인쇄
    gl17InvoiceInput_enter: (ctx) => ctl().scan(ctx.value ?? ''),
  },
  // 슬롯이 이미 큰 토스트로 알렸다 — 생성본이 다시 던지지 않게 받아 둔다.
  onActionError: () => undefined,
  texts: {
    gl17AttachText: () => ctl().attachText,
    gl17OrgInvoiceText: () => ctl().orgInvoiceText,
    gl17ResultText: () => ctl().resultText,
  },
  fields: {
    gl17AutoRecordSwitch: () => ctl().autoRecordField,
    gl17SecondsInput: () => ctl().secondsField,
    gl17WidthInput: () => ctl().widthField,
    gl17HeightInput: () => ctl().heightField,
    gl17InvoiceInput: () => ctl().invoiceField,
  },
  recording: {
    gl17Recording: () => ctl().recording,
  },
}
